import { call, select, put } from 'redux-saga/effects';
import API from "../../API";
import {addTaxonomyError, addTaxonomySuccess, inputError} from "./add-taxonomy-action-creators";
import {validate} from "../login/utility";
import {addNotificationRequest} from "../notifications/notifications-action-creators";
import {showAddWordsModal} from "../add-words/add-words-action-creators";


export default function* addTaxonomy({ history }) {

  const id  = yield select(state => state.addTaxonomy.id);
  const idValid = yield call(validate, { input: id, action: inputError});
  if (idValid) {
    try {
      const result = yield call(API.addTaxonomy, { id: id.value });
      console.log(result, 'RESULT FROM ADD TAXONOMY');
      if (result.data) {
        yield put(addTaxonomySuccess());
        yield put(addNotificationRequest(
          {
            status: "Success",
            message: [`Taxonomy ${id.value} was added successfully.`]}
          ));
        yield put(showAddWordsModal());
        history.goBack();
      } else {
        yield put(addTaxonomyError());
        yield put(addNotificationRequest({ status: "Error", message: ["Something went wrong..."]}))

      }
    } catch(error) {
      console.log(error, 'ERROR FROM ADD TAXONOMY');
      yield put(addTaxonomyError());
      yield put(addNotificationRequest({ status: "Error", message: ["Something went wrong..."]}))
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/add-taxonomy/add-taxonomy-saga.js